// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"5f2fd194","100":"414567a1","478":"162e53ad","535":"effbf823","936":"1843744c","968":"f94fcaa8"}[chunkId] + ".chunk.js";
};